import { QueryClient } from "@tanstack/react-query";

import { STALE_TIME } from "#app/http/ReactQueryProvider";
import {
  fetchMaterialsVolumetricPrice,
  MaterialsVolumetricPriceDto,
} from "#modules/materials/infra/fetchMaterialsVolumetricPrice.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const materialsVolumetricPriceQuery = () => ({
  queryKey: queryKeys.materials.volumetricPrice,
  queryFn: () => fetchMaterialsVolumetricPrice(),
  staleTime: STALE_TIME,
  suspense: true,
});

export const getMaterialsVolumetricPriceQueryData = (
  queryClient: QueryClient,
): MaterialsVolumetricPriceDto | undefined => {
  return queryClient.getQueryData<MaterialsVolumetricPriceDto>(queryKeys.materials.volumetricPrice);
};

type MaterialsVolumetricPriceQueryDataUpdater =
  | MaterialsVolumetricPriceDto
  | undefined
  | ((old: MaterialsVolumetricPriceDto | undefined) => MaterialsVolumetricPriceDto | undefined);

export const setMaterialsVolumetricPriceQueryData = (
  queryClient: QueryClient,
  updater: MaterialsVolumetricPriceQueryDataUpdater,
): MaterialsVolumetricPriceDto | undefined => {
  return queryClient.setQueryData<MaterialsVolumetricPriceDto>(
    queryKeys.materials.volumetricPrice,
    updater,
  );
};
